import React from "react";

const CGV = () => {
  return (
    <section className="min-h-[70vh] flex items-center justify-center bg-white py-16 px-6">
      <div className="max-w-5xl w-full space-y-12">
        <header className="text-center space-y-4">
          <p className="text-sm tracking-[0.4em] uppercase text-gray-400">
            Informations légales
          </p>
          <h1 className="text-[#f36e26] text-4xl sm:text-5xl font-extrabold">
            Conditions Générales d’Utilisation et de Vente
          </h1>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
            Ce document détaille les règles applicables aux réservations, aux ateliers
            créatifs et au fonctionnement du café-atelier Mood. Merci de prendre le
            temps de le consulter avant toute réservation.
          </p>
        </header>

        <article className="space-y-8 rounded-3xl border border-orange-100 bg-orange-50/40 p-8 shadow-sm">
          <div className="space-y-4">
            <h2 className="text-[#f36e26] text-2xl font-bold">
              1. Conditions Générales d’Utilisation et de Vente
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Ce site est publié par Mood, SARL au capital de 2000€, dont le siège est
              situé 4ter rue d’Orange 37400 AMBOISE, immatriculée auprès du registre du
              commerce et des sociétés de TOURS sous le numéro SIREN 990 394 868,
              représentée par Camille DETRUE, gérante, dûment habilitée aux fins des
              présentes. Mood est joignable par email : contact@mood-cafe-atelier.com.
            </p>
          </div>

          <div className="space-y-6 text-gray-700 leading-relaxed">
            <section className="space-y-3">
              <h3 className="text-[#f58f55] text-xl font-semibold">Objet</h3>
              <p>
                Mood est un café-atelier qui propose des ateliers de peinture sur
                céramique en session sur des créneaux horaires et des événements
                ponctuels à des fins de loisirs créatifs, artistiques et récréatifs,
                pour les particuliers et les entreprises. Consulté notre page Instagram 
                ou Facebook pour avoir un aperçu des pièces disponible chez Mood.
                Mood propose également la vente
                de produits de petite restauration et de boissons.
              </p>
            </section>

            <section className="space-y-3">
              <h3 className="text-[#f58f55] text-xl font-semibold">
                Acceptation des conditions générales d’utilisation et de vente
              </h3>
              <p>
                En confirmant votre réservation, vous reconnaissez avoir pris
                connaissance des présentes conditions générales d’utilisation et de
                vente et les acceptez dans leur intégralité. Mood se réserve le droit
                de modifier, à tout moment, les présentes conditions générales, qui
                seront applicables à toute réservation effectuée après la date de
                modification.
              </p>
            </section>

            <section className="space-y-3">
              <h3 className="text-[#f58f55] text-xl font-semibold">
                Inscription aux sessions et événements
              </h3>
              <p>
                L’inscription aux ateliers se fait sur le site internet de Mood dans la
                limite des places disponibles. L’inscription devient définitive à
                réception d’un e-mail de confirmation de Mood. Aucune confirmation
                papier ne sera envoyée. Mood se réserve le droit d’annuler la
                réservation lorsque l’identité du client, son téléphone ou son adresse
                e-mail sont inexactes. En cliquant sur le bouton « réserver » à la fin
                du formulaire de réservation, vous acceptez pleinement et sans réserve
                les présentes Conditions Générales.
              </p>
              <p>
                En cas d’empêchement, merci d’annuler votre réservation au moins 24h à
                l’avance afin de libérer le créneau et de permettre à d’autres clients
                d’en profiter.
              </p>
            </section>

            <section className="space-y-3">
              <h3 className="text-[#f58f55] text-xl font-semibold">Prix</h3>
              <p>
                Les prix de vente affichés dans l’établissement sont librement fixés et
                indiqués en euros toutes taxes comprises. Tous les prix présentés par
                Mood sont non négociables. Le prix intégral est à régler à la fin de la
                session en carte bleue ou en espèces.
              </p>
            </section>

            <section className="space-y-3">
              <h3 className="text-[#f58f55] text-xl font-semibold">Produits et services</h3>
              <p>
                Les illustrations ou photos présentées sur le site n’ont pas de valeur
                contractuelle. Elles sont fournies à titre indicatif afin d’inspirer les
                participants.
              </p>
            </section>

            <section className="space-y-3">
              <h3 className="text-[#f58f55] text-xl font-semibold">Délais de rétractation</h3>
              <p>
                Conformément aux articles L 121-20-4 et L 221-18 du code de la
                consommation, les réservations de session, d’événements ou d’achats de
                bons cadeaux ne font pas l’objet d’un droit de rétractation. Toute
                commande est ferme et définitive.
              </p>
              <p>
                Vous serez informé de l’éventuelle annulation de la session ou de
                l’événement, de son report ou de sa modification substantielle par Mood.
                En vous inscrivant à une session ou à un événement, vous acceptez
                expressément de renoncer à tout recours contre Mood aux fins de
                remboursement. Certaines sessions peuvent toutefois faire l’objet d’un
                échange si cela est indiqué explicitement dans leur descriptif.
              </p>
            </section>

            <section className="space-y-3">
              <h3 className="text-[#f58f55] text-xl font-semibold">Responsabilité</h3>
              <p>
                Les sessions impliquent la participation active du client. Ce dernier
                accepte de se montrer vigilant et de respecter les consignes données par
                l’équipe Mood. Mood ne pourra être tenue responsable des dommages causés
                à la personne du client ou à ses biens lors des sessions de peinture, ni
                de tout dommage ou perte des objets personnels apportés par le client.
              </p>
              <p>
                Le client accepte que Mood puisse utiliser les coordonnées saisies lors
                de la réservation pour lui fournir des informations complémentaires,
                l’informer d’une modification ou préciser la marche à suivre. Un retard
                jusqu’à 15 minutes après le début de l’événement est toléré. Au-delà,
                la participation pourra être refusée pour préserver le bon déroulé de
                l’atelier. Les mineurs de moins de 16 ans doivent être accompagnés par
                un majeur responsable.
              </p>
            </section>

            <section className="space-y-3">
              <h3 className="text-[#f58f55] text-xl font-semibold">
                Confidentialité et données personnelles
              </h3>
              <p>
                Les informations recueillies lors de la réservation font l’objet d’un
                traitement destiné à assurer un meilleur suivi. Mood veille à ce que ces
                données restent confidentielles et ne les communique pas à des
                partenaires commerciaux ou à des tiers, sauf autorisation préalable du
                client. Elles peuvent servir à proposer ultérieurement des offres
                commerciales (newsletter, informations produits, services et événements).
              </p>
              <p>
                L’utilisateur peut se désinscrire via le lien présent dans la
                newsletter. Conformément à la loi « Informatique et Libertés » du 6
                janvier 1978 modifiée, le client bénéficie d’un droit d’accès et de
                rectification en s’adressant à Mood, 4ter rue d’Orange 37400 AMBOISE. Il
                peut également s’opposer au traitement de ses données ou les modifier
                depuis la rubrique « contact » sur www.mood-cafe-atelier.com.
              </p>
              <p>
                Mood se réserve le droit d’utiliser, sauf avis contraire écrit du
                client, les images et vidéos de ses ateliers à des fins de promotion.
              </p>
            </section>

            <section className="space-y-3">
              <h3 className="text-[#f58f55] text-xl font-semibold">Loi applicable</h3>
              <p>
                Les présentes conditions générales sont soumises à la loi française. En
                cas de litige, l’acheteur s’engage à s’adresser en priorité à Mood via
                son site pour trouver une solution amiable.
              </p>
            </section>

            <section className="space-y-3">
              <h3 className="text-[#f58f55] text-xl font-semibold">
                Assurance responsabilité civile
              </h3>
              <p>
                La responsabilité civile du vendeur est couverte par le contrat
                n°426372660001, auprès de la compagnie GROUPAMA.
              </p>
            </section>
          </div>
        </article>

        <article className="space-y-8 rounded-3xl border border-orange-100  bg-orange-50/40 p-8 shadow-sm">
          <div className="space-y-4">
            <h2 className="text-[#f36e26] text-2xl font-bold">
              2. Règlement intérieur du café céramique Mood
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Les clients se rendant au café céramique Mood déclarent avoir pris
              connaissance du présent règlement intérieur et l’acceptent dans son
              intégralité.
            </p>
          </div>

          <div className="space-y-6 text-gray-700 leading-relaxed">
            <section className="space-y-3">
              <h3 className="text-[#f58f55] text-xl font-semibold">
                Organisation de l’activité
              </h3>
              <p>
                Nos peintures à céramique se nettoient à l’eau, sont non toxiques, ne
                contiennent pas de plomb et sont compatibles avec une utilisation
                alimentaire après cuisson. Ne pas ingérer.
              </p>
              <p>
                Les accessoires et matériels sont mis à disposition pour faciliter votre
                création. Merci de respecter les lieux, le matériel et les autres
                participants, et de laisser l’espace propre à votre départ. L’équipe de
                Mood se charge du nettoyage du matériel utilisé.
              </p>
              <p>
                Les céramiques sont à récupérer au Mood sous 2 à 3 semaines après leur
                réalisation. À la fin de la session, prenez en photo votre
                céramique peinte et inscrivez la date du jour.
                La photo sera demandée lors du retrait.
              </p>
              <p>
                Les pièces sont conservées pendant 60 jours après leur réalisation. Passé
                ce délai, Mood se réserve le droit de les céder à des associations
                caritatives ou d’organiser une brocante à des fins caritatives.
              </p>
              <p>
                Les sessions durent 2h. Merci de respecter les horaires afin de laisser
                la place aux participants suivants. Les personnes souhaitant peindre sont
                prioritaires sur celles qui souhaitent uniquement consommer.
              </p>
              <p>
                Certaines pièces peuvent présenter des imperfections après cuisson,
                témoignant du caractère artisanal du travail. Les céramiques en attente,
                exposées ou rangées ne doivent pas être manipulées par d’autres
                participants. Tout objet cassé ou endommagé sera facturé. Les bons
                cadeaux sont valables un an à compter de la date d’achat.
              </p>
              <p>
                Les participants s’engagent à respecter la propriété intellectuelle des
                illustrations ou céramiques réalisées et à ne pas reproduire des œuvres
                protégées ni destiner leurs imitations à la vente.
              </p>
            </section>

            <section className="space-y-3">
              <h3 className="text-[#f58f55] text-xl font-semibold">Sécurité</h3>
              <p>
                Les participants sont invités à ne pas laisser leurs affaires sans
                surveillance. Mood ne pourra être tenue responsable d’un vol. Les
                enfants de moins de 16 ans doivent être accompagnés d’une personne
                majeure.
              </p>
              <p>
                Conformément à la loi, les boissons alcoolisées sont interdites aux
                mineurs de moins de 18 ans. Mood s’engage à ne pas communiquer les
                données personnelles des participants à des tiers. Toute violation du
                règlement intérieur pourra mener à une demande de quitter l’établissement
                sans délai.
              </p>
            </section>

            <section className="space-y-3">
              <h3 className="text-[#f58f55] text-xl font-semibold">
                Situations de handicap
              </h3>
              <p>
                L’entrée et la circulation au sein de l’établissement sont accessibles
                aux personnes à mobilité réduite. Le comptoir est adapté et les toilettes
                permettent d’accueillir un fauteuil roulant. Notre équipe reste à votre
                disposition pour toute situation de handicap.
              </p>
            </section>

            <section className="space-y-3">
              <h3 className="text-[#f58f55] text-xl font-semibold">
                Prises de vue et droit à l’image
              </h3>
              <p>
                Dans le cadre de sa communication, Moos peut réaliser des photographies 
                ou vidéos d’ambiance au sein de l’établissement, susceptibles d’être diffusées 
                sur ses supports de communication (réseaux sociaux, site internet, 
                supports promotionnels).
                </p>
                <p>
                Ces prises de vue ont pour objectif de présenter l’activité et l’atmosphère du lieu,
                sans ciblage volontaire d’un client en particulier.
                Tout client dispose d’un droit d’opposition à l’utilisation de son image. 
                Il peut l’exercer à tout moment en le signalant à l’équipe sur place ou 
                en écrivant à <a className="text-bold underline text-orange-600" href="mailto:contact@mood-cafe-atelier.com" alt="mail: Contact@mood-cafe-atelier.com">contact@mood-cafe-atelier.com</a>.
                En cas d’opposition, Mood s’engage à ne pas utiliser ou à retirer dans un délai raisonnable toute image concernée, lorsque cela est techniquement possible.
                </p>
            </section>
          </div>
        </article>
      </div>
    </section>
  );
};

export default CGV;
